import React from "react";
import { Box } from "@mui/system";
import Sidebar from "./sidebar";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { DataGrid } from "@mui/x-data-grid";
import CustomToolbar from "./CustomToolbarPrint";
import Modal from "@mui/material/Modal";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
//import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";

import EditIcon from "@mui/icons-material/Edit";
import OutboxIcon from "@mui/icons-material/Outbox";

import { useNavigate, useLocation } from "react-router-dom";

import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase.js";

import "../App.css";

const steps = [
  "General Information",
  "Contract Details",
  "Emergency Contact",
  "Training",
  "Correspondence",
  "Files",
];

let trainingTypeOLD = [
  "CSCS",
  "Streetworks",
  "CPC Driver Qualification",
  "Tacho Driver",
  "CPCS Number",
  "SWQR Number",
  "CITB Test ID",
  "CITB Number",
  "NPORS Number",
  "SHEA Telecommunications",
  "IPAF 3a and 3b",
  "NPORS  Telescopic Handler ex 360 slew",
  "NPORS Forward Tipping Dumper Wheeld All Sizes Excluding Mini/Skip",
  "NPORS Rear Tipping Dumper (Srticulated/Wheeled/Above and Below 10 Tonne)",
  "Npors Excavator 180  below 5 ton",
  "NPORS Skidsteer Loader (Wheeled)",
  "NPORS Excavator below 10 tonne  tracked",
  "NPORS 360 Excavator Above and Below 10 Tonne Tracked",
  "NPORS  Slinger/Signaller",
  "NPORS Road Roller",
  "CPCS Forward Tipping Dumper - Wheeled",
  "CPCS Forward Tipping Dumper - Tracked",
  "CPCS Ride on Roller",
  "CPCS Appointed Person",
  "CPCS 180 Below 5 Tonne",
  "CPCS 180 Above 5 Tonne",
  "CPCS 360 Below 10 Tonne - Tracked",
  "CPCS 360 Above 10 Tonne - Tracked",
  "CPCS 360 Below 10 Tonne - Wheeled",
  "CPCS 360 Above 10 Tonne - Wheeled",
  "CPCS 360 Below 10 Tonne - Tracked - Lifting Operations",
  "CPCS 360 Above 10 Tonne - Tracked - Lifting Operations",
  "SSP - Health and Safety Awareness",
  "SSP - SSSTS",
  "SSP - SMSTS",
  "SSP - SEATS",
  "SSP - Directors Role in Health and Safety",
  "Carmel 180 Excavator All Sizes Wheeled",
  "Carmel Ride on Roller",
  "Carmel Forward Tipping Dumper Wheeled",
  "Carmel Confined Space Entry",
  "Carmel 360 Below 10 Tonne Tracked",
  "Carmel/npors Quick Hitch",
  "Carmel Skid Steer - Wheeled",
  "MGL Quick Hitch",
  "Oil Spill Responder",
  "Pipeline and Plant Training Specialist - Telehandler",
  "Face Fit",
  "Confined Spaces (Level Unknown)",
  "City and Guilds Confined Space - Medium Risk",
  "Vehicle Banksman",
  "Fire Warden",
  "IOSH Managers",
  "Scaffold Inspection",
  "PASMA Tower",
  "EPF  Edge protection",
];
let trainingType = [
  "Volunteer Code of Conduct",
  "Lone Working Policy and Procedure",
  "Conflict Resolution",
  "Food Handling, Safety & Hygiene",
  "First Aid",
  "Fire Safety",
  "Safeguarding",
  "Health & Safety",
  "Data Protection",
  "Drugs & Alcohol",
  "Naloxone",
  "Bereavement and Trauma",
];

let qualificationType = [
  "Level 2 NVQ Diploma in Construction Operations and Civil Engineering Services",
  "Level 2 NVQ in Plant Operations - Slinger Signaller/Loader Securer",
  "Level 6 NVQ Diploma in Construction Contracting Operations Management",
  "Level 2 NVQ Diploma in Land Drilling Lead Driller",
  "City and Guilds Number",
  "Manual Handling",
  "Cat and Genny",
  "Asbestos Awareness",
  "Abrasive Wheels",
  "SWQR Operator",
  "Emergency First Aid at Work",
  "First Aid at Work",
  "Bricklaying",
];
trainingType = trainingType.sort((a, b) => a.localeCompare(b));
qualificationType = qualificationType.sort((a, b) => a.localeCompare(b));

export default function Profile() {
  const [inputList, setInputList] = React.useState([
    { firstName: "", lastName: "" },
    1,
    2,
    2,
  ]);
  const [inputList1, setInputList1] = React.useState([
    { firstName: "", lastName: "" },
    1,
  ]);
  const [value, setValue] = React.useState("1");
  const [open, setOpen] = React.useState(false);
  const [dataConc, setdataConc] = React.useState({ concComment: "" });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRowClick = (params) => {
    console.log(params.row);
    setdataConc(params.row);
    handleOpen();
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const employee = useLocation().state.employee;

  const columns = [
    { field: "concDate", headerName: "Date", width: 150 },

    {
      field: "concType",
      headerName: "Type",
      width: 150,
    },
    { field: "concComment", headerName: "Information", width: 370 },
    { field: "concLog", headerName: "Logged By", width: 150 },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Sidebar />

      {/* Modal */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "#ffffff",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <div className="LoginPage">
            <TextField
              type="date"
              label="Date"
              InputLabelProps={{ shrink: true }}
              className="addform"
              style={{ width: "45%" }}
              id="outlined-basic"
              variant="outlined"
              value={dataConc.concDate}
            />
            <FormControl style={{ width: "45%" }}>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                value={dataConc.concType}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Type"
              >
                <MenuItem value={"Accident"}>Accident</MenuItem>
                <MenuItem value={"Disciplinary"}>Disciplinary</MenuItem>
                <MenuItem value={"null"}></MenuItem>
              </Select>
            </FormControl>
            <TextField
              type="text"
              label="Logged By"
              InputLabelProps={{ shrink: true }}
              className="addform"
              style={{ width: "100%" }}
              id="outlined-basic"
              variant="outlined"
              value={dataConc.concLog}
            />
            <TextField
              value={dataConc.concComment}
              className="addform"
              style={{ width: "100%" }}
              // id={ `tt_description_text outlined-multiline-static`}
              label="Add a comment "
              multiline
              rows={10}
              // onBlur={ (f)=>(this.textOnBlur({id:answeringPainSpot.spotId, value:f.target.value, doc_name:answeringPainSpot.doc_name})) }
            />
          </div>
        </Box>
      </Modal>

      <Button
        variant="contained"
        onClick={() => {
          navigate("/profileUpdateStaff", {
            state: {
              employee: employee,
            },
          });
        }}
        style={{
          position: "absolute",
          right: "15px",
          bottom: "20px",
          borderRadius: "50",
          width: "50px",
          height: "50px",
          backgroundColor: "#1c3261",
        }}
      >
        <EditIcon />
      </Button>
      <Button
        variant="contained"
        onClick={async () => {
          await addDoc(collection(db, "staff"), employee);
          await deleteDoc(doc(db, "archivedStaff", employee.doc));
          alert("Archived Successfully");
          navigate("/home");
        }}
        style={{
          position: "absolute",
          left: "250px",
          bottom: "20px",
          borderRadius: "50",
          width: "50px",
          height: "50px",
          backgroundColor: "#1c3261",
        }}
      >
        <OutboxIcon />
      </Button>

      <Box sx={{ width: "60%" }}>
        <Stepper
          nonLinear
          activeStep={activeStep}
          alternativeLabel
          sx={{
            "& .Mui-active": {
              color: "#1c3261",
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <div className="LoginPage2">
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Employee Added Sucessfully!!
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset} style={{ color: "#1c3261" }}>
                    Add New
                  </Button>
                </Box>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* ADDING FORM */}

              {activeStep == 0 ? (
                <div className="LoginPage">
                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.firstName}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Surname"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.surName}
                    active
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Gender
                    </InputLabel>
                    <Select
                      value={employee.gender}
                      // onChange={(e) => setlocation(e.target.value)}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem value={"male"}>Male</MenuItem>
                      <MenuItem value={"female"}>Female</MenuItem>
                      <MenuItem value={"null"}></MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Job Title"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.jobTitle}
                    active
                  />
                  <TextField
                    type="email"
                    className="addform"
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.email}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 1"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.address1}
                    active
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Contact"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.contact}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 2"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.address2}
                    active
                  />
                  <TextField
                    type="date"
                    label="Date of Birth"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    value={employee.DOB}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Town/County"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.town}
                    active
                  />

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Post Code"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.postCode}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Driving Licence"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.drivingLicence}
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      marginTop: "30px",
                      width: "49%",
                      color: "#1c3261",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      height: "50px",
                      marginTop: "30px",
                      backgroundColor: "#1c3261",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 1 ? (
                <div className="LoginPage">
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="National Insurance Number"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nationalIns}
                    active
                  />
                  <TextField
                    type="date"
                    label="Start Date"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    value={employee.startDate}
                    active
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Rate of Pay £"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.rateOfPay}
                    active
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Period of Pay
                    </InputLabel>
                    <Select
                      value={employee.periodOfPay}
                      active
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem value={employee.periodOfPay}>{employee.periodOfPay}</MenuItem>
                  
                    </Select>
                  </FormControl>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                      Contract Signed
                    </FormLabel>
                    <RadioGroup
                      value={employee.contarctSigned}
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="NO"
                      />
                    </RadioGroup>
                  </FormControl>

                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                    Probation Period
                    </InputLabel>
                    <Select
                      value={employee.probaition}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem value={employee.probaition}>{employee.probaition}</MenuItem>
                      
                    </Select>
                  </FormControl>
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Volunteer
                    </InputLabel>
                    <Select
                      value={employee.volunteer}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="periodOfpay"
                    >
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                      <MenuItem value={"null"}></MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Relationship"
                    variant="outlined"
                    style={{ width: "45%", visibility: "hidden" }}
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      backgroundColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 2 ? (
                <div className="LoginPage">
                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="Next of kin Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nextOfKinName}
                    active
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Number"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nextOfKinNumber}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Relationship"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nextOfKineRelationship}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Relationship"
                    variant="outlined"
                    style={{ width: "45%", visibility: "hidden" }}
                  />

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "40%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "40%",
                      backgroundColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 3 ? (
                <div className="LoginPage">
                  {employee.training.map((x, i) => {
                    return (
                      <div style={{ width: "100%" }}>
                        <FormControl style={{ width: "45%" }}>
                          <InputLabel id="demo-simple-select-label">
                            Training Type
                          </InputLabel>
                          <Select
                            // onChange={e => handleInputChange(e, i)}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Location"
                            value={x.training}
                          >
                          
                              <MenuItem value={x.training}>{x.training}</MenuItem>
                          
                          </Select>
                        </FormControl>

                        <TextField
                          type="date"
                          label="Expiry Date"
                          InputLabelProps={{ shrink: true }}
                          className="addform"
                          style={{ width: "45%", marginLeft: "10px" }}
                          id="outlined-basic"
                          variant="outlined"
                          value={x.date}
                        />
                      </div>
                    );
                  })}

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      backgroundColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 4 ? (
                <div className="LoginPage">
                  <div style={{ height: 340, width: "100%" }}>
                    <DataGrid
                      rows={employee.conc}
                      columns={columns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      style={{ width: "100%" }}
                      onRowDoubleClick={handleRowClick}
                      // getRowClassName={(params) => `${params.row.color}`}
                      components={{
                        Toolbar: CustomToolbar,
                      }}
                    />
                  </div>

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "49%",
                      backgroundColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : (
                <div className="LoginPage">
                  <ul>
                    {employee.files.map((item) => {
                      return (
                        <li>
                          <a
                            href={item.url}
                            target="_blank"
                            download={item.name}
                          >
                            {item.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>

                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "49%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                
                </div>
              )}

              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                
                <Box sx={{ flex: "1 1 auto" }} />
                
              </Box>
            </React.Fragment>
          )}
        </div>
      </Box>

      
    </Box>
  );
}
